import { isProblemDetails, PROBLEM } from '@hpd/contract';
import { queryOptions } from '@tanstack/react-query';

import { api } from '../api.ts';

// `/v1/me` is how a client establishes its session: it is the first call every surface makes, and
// the one that discovers whether the API will have this user at all. Shared query options rather
// than a hook, so the layout route and the screen underneath it read one cached result.

/** An API refusal, carrying the RFC 9457 `type` to branch on rather than a status or a message. */
export class ApiProblem extends Error {
  constructor(
    readonly type: string,
    message: string,
    /** A problem's own fields beyond the standard ones, e.g. `unit` on measure-required. */
    readonly extensions: Readonly<Record<string, unknown>> = {},
  ) {
    super(message);
    this.name = 'ApiProblem';
  }
}

export const meQuery = queryOptions({
  queryKey: ['me'],
  queryFn: async () => {
    const { data, error } = await api.GET('/v1/me');
    if (error) {
      throw isProblemDetails(error)
        ? new ApiProblem(error.type, error.detail ?? error.title)
        : new ApiProblem('unknown', 'Could not load your details.');
    }
    return data;
  },
});

export function isMfaRequired(error: unknown): boolean {
  return error instanceof ApiProblem && error.type === PROBLEM.mfaRequired;
}
